import { useQuery } from '@apollo/client'
import _ from 'lodash'
import { useContext, useState } from 'react'

import { ITERATEE } from 'components/TransferList'
import { AddEditPageContext } from 'features/inventory/page/contexts/AddEditPageContext'
import { AdUnitForPageTransferList } from './adUnitForPageTransferList'
import { adUnitForPageTransferListFromDTO } from './api/mapper'
import { GET_AD_UNITS_FOR_PAGE_TRANSFER_LIST } from './api/query'
import { AdUnitForPageTransferListDTO } from './api/types'
import { UseGetAdUnitsForPageTransferList, UseGetAdUnitsForPageTransferListProps } from './types'
import { sorted } from './utils'

export const useGetAdUnitsForPageTransferList = ({
  domainId,
}: UseGetAdUnitsForPageTransferListProps): UseGetAdUnitsForPageTransferList => {
  const { page } = useContext(AddEditPageContext)
  const [all, setAll] = useState<AdUnitForPageTransferList[]>([])

  const active: AdUnitForPageTransferList[] = page?.adUnits ?? []

  const { loading } = useQuery(GET_AD_UNITS_FOR_PAGE_TRANSFER_LIST, {
    onCompleted: ({ node: { adUnits } }) => {
      setAll(
        sorted(
          adUnits.map(
            (adUnit: AdUnitForPageTransferListDTO): AdUnitForPageTransferList =>
              adUnitForPageTransferListFromDTO(adUnit),
          ),
        ),
      )
    },
    skip: !domainId,
    variables: { domainId },
  })

  return {
    active,
    all,
    available: _.differenceBy(all, active, ITERATEE),
    loading,
  }
}
